<template>
    <Dialog v-model:open="open">
        <DialogContent class="sm:max-w-[425px]">
            <DialogHeader>
                <DialogTitle>Generate password</DialogTitle>
            </DialogHeader>
            <Password v-model="password" disabled />
        </DialogContent>
    </Dialog>
</template>

<script setup lang="ts">
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Password } from "@/components/ui/input";
import { ref } from "vue";

const open = defineModel();
const password = ref("");
</script>
